export default __webpack_public_path__ + "static/media/ColorPickerBackground.42b6155f.webp";